export enum TransformerSet {
  Default = 'default',
  PreserveKeys = 'preserve_keys',
}
